<template>

  <div>
    <div class = "e-title-card-box">
      <div class = "e-bread-box">
        <a-row>
          <a-col :span="20" >
            <a-menu v-model="current" mode="horizontal" @click="menuClick">

              <a-menu-item v-for="item in menus" :key="item.key">
                <router-link :to="item.url"  style="display: flex;    vertical-align: middle;    align-items: center;">
                  <!-- <a-icon :type='item.iconName' /> -->
                  <img :src="item.cIcon" alt="" class="e-img">
                  {{item.title}}
                </router-link>
              </a-menu-item>
            </a-menu>
          </a-col>

          <a-col :span="4">
              运行时长：{{this.TotalDuration}}
          </a-col>

        </a-row>

      </div>
      <!-- <div class = "e-title-box">
        当前数据时间:2020-06-29 10:11:59
      </div> -->
    </div>

    <router-view></router-view>
  </div>

</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'

  export default {
    name: 'fishTypeForm',
    components: {
    },
    data() {
      return {
        current:'',// ['equipmentData'],
        menus:[],
        device:{},
        TotalDuration:'',
        queryInfo:{
          productkey:"",
          devicename:"",cSystemCode:'节水灌溉',
          keyword:""
        },
        timer: '',//定时器
        // urls:{
        //   equipmentDataUrl:{},
        //   equipmentControlUrl:{},
        //   alarmEventsUrl:{},
        //   autoControlUrl:{},
        //   intelligentPushUrl:{},
        //   intelligentPredictionUrl:{},
        // }
      }
    },
    created(){
      this.menus=[
        {key:"equipmentData",cIcon:require("../../../equipmentimg/icon_27.png"),keyPath:["equipmentData"],title:"电量水量",url:{path:"/energyanalsis/equipmentDetails",query:{IotId:this.getIotId,TotalDuration:this.getTotalDuration}}},
        {key:"equipmentControl",cIcon:require("../../../equipmentimg/icon_32.png"),keyPath:["equipmentControl"],title:"运行时长",url:{path:"/energyanalsis/equipmentDetails/equipmentControl/equipmentControlList",query:{IotId:this.getIotId,TotalDuration:this.getTotalDuration}}},
         ]
      this.current=this.menus[0].keyPath

      var device=this.$store.getters.Devices.filter(x=>x.IotId==this.getIotId)[0]
      if(device!=null) this.device=device
      this.queryInfo.productkey=this.device.ProductKey
      this.queryInfo.devicename=this.device.DeviceName

      this.TotalDuration=this.$route.query.TotalDuration


    },
    mounted(){
    //  this.timer= setInterval(this.getDevices, 10000);//定时10秒

    },
    methods:{

      menuClick({ item, key, keyPath }){

        this.current=keyPath
      },
      async getDevices(){
        const {data:res} = await this.$http.post('WLWDevice/List',this.queryInfo)
        if(res.code=="200"){
          if(res.obj.list.length>0){
            this.device=res.obj.list[0]
          }
        }
        else{

        }
      }
    },
    computed:{
      getIotId(){
        return this.$route.query.IotId
      }
      ,getTotalDuration(){
        return this.$route.query.TotalDuration
      }
    },
    beforeDestroy(){
     // clearInterval(this.device.timer)
    }
  }
</script>

<style scoped>
  .e-img{
    height: 20px;
    width: 20px;
  }

  .e-title-card-box{
    background-color: #07294F;
    width:97%;
    margin-left: 18px;
    margin-bottom: 16px;
  }

  .e-bread-box{
    margin-left: 12px;
    padding-top: 16px;
    /*display: flex;*/
    /*justify-content: space-between;*/
    background-color: #07294F;
  }

  .e-title-box{
    margin-left: 12px;
    padding-bottom: 20px;
    padding-top: 20px;

    /*font-size: 130%;*/
    /*font-weight: bolder;*/
  }
</style>
<style>

  body{
    color:#ffffff;
  }.ant-select-selection {
    /* background-color: #0A2D57 !important;*/
   }
  .ant-input{
  /* color: #ffffff;*/
 }
</style>


